import {setDesign, setLanguage, setReturnUrl} from "../GlobalConfiguration";


/**
 * Sets properties for page personalisation (e.g. design, language)
 * @param queryStringParams mandatory parameter
 */
export function setProperties(queryStringParams) {

    if(queryStringParams.paymentSystem === undefined && queryStringParams.paymentSystem === ''){
        setDesign("default");
    } else{
        setDesign(queryStringParams.paymentSystem)
    }

    if(queryStringParams.language !== undefined && queryStringParams.language !== ''){
        setLanguage(queryStringParams.language)
    }

    if(queryStringParams.returnUrl !== undefined && queryStringParams.returnUrl !== ''){
        setReturnUrl(queryStringParams.returnUrl)
    }
}


// WEBPACK FOOTER //
// ./src/js/util/DefaultProperties.js